module.exports = __webpack_public_path__ + "img/HHCarousel_router.1199023d.jpg";